<input
  ngxDaterangepickerMd
  class="form-control"
  [disabled]="disabled"
  [(ngModel)]="value"
  [ranges]="ranges"
  [singleDatePicker]="singleDatePicker"
  [showDropdowns]="false"
  [showRangeLabelOnInput]="showRangeLabelOnInput"
  [alwaysShowCalendars]="false"
  [autoApply]="true"
  [closeOnAutoApply]="true"
  [linkedCalendars]="true"
  [showCustomRangeLabel]="showCustomRangeLabel"
  [opens]="opens"
  startKey="start_date"
  endKey="end_date"
  [locale]="{ format: 'YYYY-MM-DD' }"
  [placeholder]="placeholder"
  (datesUpdated)="onDatesUpdated($event)"
/>
